module.exports = __webpack_public_path__ + "img/tongji.c92c9565.png";